import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import TaskTemplateService from "../../src/Services/TaskTemplate.service";
const TaskTemplateLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "title",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<TaskTemplate[]>' is not assignable to type '(ids: string[]) => Promise<TaskTemplate[]>'.
        fetchItemsById: (ids) => {
            return TaskTemplateService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return TaskTemplateService.searchAll(search);
        },
        optionRenderer: function optionRenderer(taskTemplate) {
            return _jsx("span", { children: taskTemplate.title });
        },
    });
};
export default TaskTemplateLookup;
